export default __webpack_public_path__ + "static/media/profile.9d4aa661.jpg";